module.exports = __webpack_public_path__ + "static/TT-Testfit_Floor18-217f35c0f27aa8dbf82ec58cf318ed6f.jpg";